import ShopriteSSO from './ShopriteSSO';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

// Action Creators
import { createNewUserOrSignIn } from '../../redux/auth/actions';
import { setLoading } from '../../redux/loading/actions';

// Redux
const mapStateToProps = (state) => {
  return {};
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    createNewUserOrSignIn,
    setLoading
  }, dispatch);
}

const ConnectedShopriteSSO = connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ShopriteSSO));

export default ConnectedShopriteSSO;



// WEBPACK FOOTER //
// ./src/pages/ShopriteSSO/index.js